import {Component, EventEmitter, forwardRef, Input, OnChanges, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Tools} from 'linkurious-shared';

const UI_CHECKBOX_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true
};

@Component({
  selector: 'checkbox',
  template: `<div class="checkbox__wrapper">
  <input type="checkbox"
         [(ngModel)]="check_option"
         [checked]="checked"
         [disabled]="disabled"
         (change)="emitChange($event.target.checked)">
  <span class="checkbox--fake"></span>
  <ng-content></ng-content>
</div>
`,
  styles: [`.checkbox__wrapper{position:relative;display:flex;align-items:center;cursor:pointer;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;box-sizing:border-box;height:18px;padding-left:29px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox__wrapper input{position:absolute;opacity:0;top:0;left:0;margin:0;width:100%;height:18px;z-index:2}.checkbox__wrapper input:disabled{cursor:default}.checkbox__wrapper input:disabled~.checkbox--fake{opacity:.4}.checkbox__wrapper input:hover:not(:disabled)~.checkbox--fake{border-color:#0081e3}.checkbox__wrapper input:checked~.checkbox--fake{border-color:#0081e3;background-color:#0081e3}.checkbox__wrapper input:checked~.checkbox--fake:after{display:block}.checkbox__wrapper .checkbox--fake{position:absolute;top:0;left:0;height:16px;width:16px;border:1px solid #878787;border-radius:2px;background-color:#fff}.checkbox__wrapper .checkbox--fake:after{content:"";position:absolute;display:none;left:5px;top:2px;width:4px;height:7px;border:solid #fff;border-width:0 2px 2px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}`],
  providers: [UI_CHECKBOX_CONTROL_VALUE_ACCESSOR]
})
export class CheckboxComponent implements ControlValueAccessor, OnChanges {

  @Input('checked') checked: boolean;
  @Input('disabled') disabled: boolean;

  @Output('trigger') trigger: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnChanges() {
    if( Tools.isDefined(this.checked) ) {
      this.check_option = this.checked;
    }
  }

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  private _check_option: any;

  set check_option(opt: any) {
    if(opt) {
      this._check_option = opt;
    }
    this.onChangeCallback(opt);
  }

  get check_option() {
    return this._check_option;
  }

  public emitChange(value: boolean){
    this.trigger.emit(value);
  }

  writeValue(obj: any): void {
    if (obj) {
      this.check_option = obj;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

}
